/** Etapas canónicas del reporte (orden fijo en UI). */
export const ORDEN_ETAPAS = ["Inicial", "Primaria", "Media General"];

/**
 * Normaliza texto de etapa (visitas, CSV plataforma) a etiqueta canónica.
 * @param {unknown} raw
 * @returns {"Inicial"|"Primaria"|"Media General"|null}
 */
export function normalizeEtapaStage(raw) {
  if (raw == null) return null;
  const s = String(raw).trim().toLowerCase();
  if (!s) return null;
  const n = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  if (n.includes("preescolar") || n.includes("inicial") || n === "ii nivel")
    return "Inicial";
  if (n.includes("primaria") || n.includes("basica") || n.includes("básica"))
    return "Primaria";
  if (
    n.includes("media general") ||
    n.includes("bachillerato") ||
    n.includes("media") ||
    n.includes("secundaria")
  )
    return "Media General";
  for (const e of ORDEN_ETAPAS) {
    if (e.toLowerCase() === s) return e;
  }
  return null;
}

/** Etapas del docente en orden canónico (solo las que declara). */
export function etapasDocenteOrdenadas(etapas) {
  const arr = Array.isArray(etapas) ? etapas : [];
  return ORDEN_ETAPAS.filter((e) => arr.includes(e));
}

/** ¿El docente dicta más de una etapa canónica? */
export function docenteTieneMultiEtapa(etapas) {
  return etapasDocenteOrdenadas(etapas).length > 1;
}
